module.exports = __webpack_public_path__ + "static/media/spoonerism-task (10).d2f39c0f.mp3";